export default __webpack_public_path__ + "static/media/loader.bd06df2d.svg";